import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon, StarIcon } from 'lucide-react';
import { extendedTestimonials } from '../data/testimonials';
export function ExtendedTestimonials() {
  return <section className="py-20 md:py-24 px-4 bg-sand" data-id="element-88" data-mp="bjw7e2yctbx8">
      <div className="max-w-6xl mx-auto" data-id="element-89" data-mp="bi1pkxidpzxd">
        <div className="text-center mb-14" data-id="element-90" data-mp="gb4hz2bf73bz">
          <h2 className="text-3xl md:text-5xl font-display font-bold uppercase text-charcoal" data-id="element-91" data-mp="gc5xpk3dse01">
            What hybrid fitness coaches are saying
          </h2>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-92" data-mp="q7pmlmjj2cfa">
          {extendedTestimonials.map((testimonial, index) => <motion.figure key={testimonial.initials} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.3,
          delay: index % 3 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className={`bg-white border border-sand-deep p-8 rounded-2xl relative shadow-sm flex flex-col h-full ${index === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-93" data-mp="u8ja4et25p7n" data-mpi={index}>
              <QuoteIcon className="absolute top-6 right-6 text-orange/15" size={48} aria-hidden="true" data-id="element-94" data-mp="33wq6jz5xdzns" />
              <div className="flex gap-1 text-copper mb-6" aria-label="5 out of 5 stars" data-id="element-95" data-mp="3vop9x6lec4qg">
                {[...Array(5)].map((_, star) => <StarIcon key={star} size={16} fill="currentColor" aria-hidden="true" data-id="element-96" data-mp="3mo98e2o7r7o8" data-mpi={star} />)}
              </div>
              <blockquote className="text-charcoal italic mb-8 relative z-10 leading-relaxed" data-id="element-97" data-mp="2bbqa4pfof8im">
                &quot;{testimonial.text}&quot;
              </blockquote>
              <figcaption className="flex items-center gap-4 mt-auto" data-id="element-98" data-mp="27rzmfu6tfoxg">
                <div className="w-12 h-12 rounded-full bg-charcoal flex items-center justify-center text-orange font-bold shrink-0" data-id="element-99" data-mp="2cr2g6ihci8q4">
                  {testimonial.initials}
                </div>
                <div data-id="element-100" data-mp="23qmdvccc97mu">
                  <div className="font-bold text-charcoal" data-id="element-101" data-mp="23puv523ub4dz">
                    {testimonial.name}
                  </div>
                  <div className="text-xs text-warmgray" data-id="element-102" data-mp="1p0ye4fjt2h18">{testimonial.role}</div>
                </div>
              </figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}